var validator = require('ui-validator');
var v = validator.validators;
var specialtiesList = require('onboarding-utils').specialtiesList;
var customEmailValidator = require('onboarding-utils').customEmailValidator;
var customCharWhitelist = require('onboarding-utils').customCharWhitelistValidator;
var customPersonName = require('onboarding-utils').customPersonNameValidator;
var additionalInfoRequired = require('onboarding-utils').additionalInfoRequiredValidator;
var howDidYouHearOpts = require('onboarding-utils').howDidYouHearOpts;

var customZipValidator = validator.createValidator(
  function(options, value, key, attributes) {
    return v.validZipcode(options)(value, key, attributes) || v.required(options)(value, key, attributes);
  }
);

module.exports = {
  specialty: {
    whitelist: v.whitelist({ whitelist: specialtiesList, message: 'Please select a valid specialty.' })
  },
  practiceDBA: {
    required: v.required({ message: 'Practice name is required.' }),
    valid: customCharWhitelist({ message: 'Practice name is not valid. Please enter letters and numbers only.' })
  },
  doctorFirstName: {
    required: v.required({ message: 'First name is required.' }),
    valid: customPersonName({ message: 'First name is not valid.' })
  },
  doctorLastName: {
    required: v.required({ message: 'Last name is required.' }),
    valid: customPersonName({ message: 'Last name is not valid.' })
  },
  phone: {
    isPhone: v.validTelephone()
  },
  zipCode: {
    isZipCode: customZipValidator({ message: 'Zip code is required.' })
  },
  firstName: {
    required: v.required({ message: 'First name is required.' }),
    valid: customPersonName({ message: 'First name is not valid.' })
  },
  lastName: {
    required: v.required({ message: 'Last name is required.' }),
    valid: customPersonName({ message: 'Last name is not valid.' })
  },
  email: {
    isEmail: customEmailValidator({ message: 'A valid email address is required.' })
  },
  howDidYouHear: {
    whitelist: v.whitelist({ whitelist: howDidYouHearOpts, message: 'How you heard about us is required.' })
  },
  howDidYouHearAdditionalInfo: {
    addlInfoRequired: additionalInfoRequired({message: 'Name of consultant, lab, vendor or lecture name is required.', howDidYouHearAboutUs: 'howDidYouHear', field: 'Consultant, lab, vendor or lecture'}),
    addlInfoRequiredMeeting: additionalInfoRequired({message: 'Meeting or tradeshow name is required.', howDidYouHearAboutUs: 'howDidYouHear', field: 'Meeting or tradeshow'})
  },
  submitType: {
    whitelist: v.whitelist({
      message: 'submitType must be get-info or enroll',
      whitelist: ['get-info', 'enroll']
    })
  }
};

require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/get-info-enroll/get-info-enroll.less');